import type { FaireProductEntity } from "../../entity_types/product";

export const p_9jxuftvpfp: FaireProductEntity = {
  token: "p_9jxuftvpfp",
  type: "product",
  name: "LM-TS-1023 Logo Adult Blue Jean Comfort Colors Tee",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/c179a9491d120d51219b37ed3a9cef36813b9f227776adea2073c44cdcff0cee.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.5,
  description: "Girlie Girl Originals presents a screen printed men’s tee. This Blue Jean Comfort Colors shirt features a bold logo print and a silhouette suited for wear. It offers construction and easy care for lasting wardrobe appeal.",
  tags: [],
  msrpDollars: 31,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:59.267Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
